import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import Modal from 'components/atoms/Modal';
import { memo } from 'react';
import { ImageFallbackProductImage } from 'utils/ImageFallback';
import styles from './style.module.css';
import { formatCurrency } from 'utils/FormatNumber';
import { encryptedData } from 'utils/helper';

const RemoveProductModal = memo(function RemoveProductModal(props) {
  const { onClose, onRemove, visible, className, restProps, product } = props;

  const defaultImage = product?.defaultImage || product?.imageUrl;
  const name = product?.name || product?.productName || '';
  const price = (() => {
    if (product?.priceDiscount) return formatCurrency(product?.priceDiscount);
    if (product?.discountPriceEncrypted) return formatCurrency(encryptedData(product?.discountPriceEncrypted));
    if (product?.priceEncrypted) return formatCurrency(encryptedData(product?.priceEncrypted));
    return product?.displayPriceFormated;
  })();

  return (
    <Modal className={className} open={visible} {...restProps} onClose={onClose}>
      <Box className={styles.confirm_modal_wrap} onClick={(e) => e.stopPropagation()}>
        <div style={{ textAlign: 'center' }}>
          <Typography className={styles.modal_title}>Xin xác nhận</Typography>
          <div className={styles.modal_content_wrap}>
            <Typography className={styles.modal_content} data-test="modal-remove-product-text">
              Bạn có chắc muốn xoá sản phẩm này khỏi giỏ hàng?
            </Typography>
          </div>
        </div>
        {product && (
          <Card className={styles.remove_item}>
            <div className={styles.remove_item_image}>
              <ImageFallbackProductImage
                className={styles.remove_item_image}
                src={defaultImage}
                size="thumbnail"
                width={80}
                height={80}
                alt={name}
              />
            </div>
            <div className={styles.remove_item_content}>
              <div className={styles.remove_item_cart_name}>{name}</div>
              <div className={styles.remove_item_cart_price}>{price}</div>
            </div>
          </Card>
        )}

        <div style={{ marginTop: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5em' }}>
          <Button variant="contained" color="success" onClick={onClose} data-test="btn-cancel-del-product-in-cart">
            Không
          </Button>

          {/* Auto focus to remove item */}
          <Button className={styles.defaultBtn} onClick={() => onRemove()} data-test="btn-ok-del-product-in-cart" id="confirm-delete">
            Có
          </Button>
        </div>
      </Box>
    </Modal>
  );
});

export default RemoveProductModal;
